export const reactTableProps = () => ({
  style: {
    width: 'calc(100vw - 350px)',
    height: 'calc(100vh - 350px)',
    fontSize: '16px',
    color: 'white',
    outline: '0',
    border: '1px solid rgba(255,255,255, .5)',
  },
})

export const tableProps = () => ({
  style: {},
})

export const theadGroupProps = () => ({
  style: {},
})

export const theadGroupTrProps = () => ({
  style: {},
})

export const theadGroupThProps = () => ({
  style: {
    outline: '0',
    borderRight: '1px solid rgba(255,255,255, .5)',
    borderBottom: '1px solid rgba(255,255,255, .5)',
  },
})

export const theadProps = () => ({
  style: {
    borderBottom: '1px solid rgba(255,255,255, .5)',
  },
})

export const theadTrProps = () => ({
  style: {},
})

export const theadThProps = () => ({
  style: {
    borderRight: '1px solid rgba(255,255,255, .5)',
    outline: '0',
  },
})

export const tBodyProps = () => ({
  style: {
    borderTop: '1px solid rgba(255,255,255, .5)',
  },
})
export const trGroupProps = () => ({
  style: {},
})

export const trProps = () => ({
  style: {},
})

export const thProps = () => ({
  style: {},
})

export const tdProps = () => ({
  style: {
    borderBottom: '1px solid rgba(255,255,255, .5)',
  },
})



// WEBPACK FOOTER //
// ./src/views/admin/styles.js